export const AAMS_REGULATORY_BAR_HEIGHT = 48;
export const AAMS_GAME_REGULATORY_BAR_HEIGHT = 32;

export const AAMS_REGULATORY_BAR = {
	CLOSED_COOKIE_NAME: "IsRegulatoryBarClosed",
	CLOSED_CLASS_NAME: "closed",
	ICON_NAME: "headerregulationicons",
};
